import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import TicketMasterCreate from '../components/ticket-master-create';

const Logo = require('../../assets/images/logo-full.png').default;

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-evenly'
    },
    logo: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        '@media (min-width: 480px)': {
            width: '90%'
        },
        '@media (min-width: 720px)': {
            width: '60%'
        },
        '@media (min-width: 1000px)': {
            width: '40%'
        }
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        '@media (min-width: 480px)': {
            width: '90%'
        },
        '@media (min-width: 720px)': {
            width: '60%'
        },
        '@media (min-width: 1000px)': {
            width: '40%'
        }
    },
    button: {
        display: 'inherit',
        width: '30%',
        backgroundColor: '#198754',
        borderColor: '#198754',
        '&:hover': {
            backgroundColor: '#198754',
            borderColor: '#198754',
            boxShadow: 'none',
        },
    },
}));

const TicketsIndex = ({ permissions }) => {

    const classes = useStyles();
    const history = useHistory();
    const [showCreateTicketMaster, setShowCreateTicketMaster] = useState(false);
    const [state, setState] = useState({
        permissions: {}
    });

    useEffect(() => {
        window.document.title = 'Tickets';

        setState(prev => ({ ...prev, permissions }));
    }, [permissions]);

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <img className={classes.logo} src={Logo} alt='logo cfg' />
                <div className={classes.buttonsContainer}>
                    {
                        state.permissions?.create_attr &&
                        <Button
                            variant='contained'
                            className={classes.button}
                            onClick={() => setShowCreateTicketMaster(true)}
                        >
                            {'Create new master ticket'}
                        </Button>
                    }
                    <Button
                        variant='contained'
                        className={classes.button}
                        onClick={() => history.push('/ticket/tickets/master/index')}
                    >
                        {'Show master tickets'}
                    </Button>
                </div>
                <div className={classes.buttonsContainer}>
                    <Button
                        variant='contained'
                        className={classes.button}
                        onClick={() => history.push('/ticket/tickets/index')}
                    >
                        {'Show tickets (breakdown)'}
                    </Button>
                    <Button
                        variant='contained'
                        className={classes.button}
                        onClick={() => history.push('/ticket/tickets/balance')}
                    >
                        {'Balance'}
                    </Button>
                </div>
            </div>

            <TicketMasterCreate open={showCreateTicketMaster} onClose={() => setShowCreateTicketMaster(false)} />
        </div>
    );
}

export default TicketsIndex;